import React from 'react'
import {
  TextInput,
  SimpleForm,
  number,
  required,
  Create,
  useNotify,
  useRedirect,
  SelectInput
} from 'react-admin'

import { Tooltip } from 'components'
import { Grid, Paper, Typography, makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  gridContainer: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
})

export const CreateForm = (props: any) => {
  const redirect = useRedirect()
  const notify = useNotify()
  const classes = useStyles()
  const {
    formTitle = '',
    shouldRedirect = true,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
    toolbar = <></>,
    aside = <></>,
    ...rest
  } = props

  const onSuccess = () => {
    notify('post_successfully')
    if (shouldRedirect) redirect(props.basePath)
    onSubmitSuccess()
  }

  const onFailure = (error: any) => {
    onSubmitFailure(error)
    notify('post_failed', 'warning')
  }

  return (
    <Create
      aside={aside}
      {...rest}
      onSuccess={onSuccess}
      onFailure={onFailure}
      className={classes.container}
    >
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        toolbar={toolbar}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
          className={classes.gridContainer}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Paper className={classes.paperContainer}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  {formTitle}
                </Typography>
                <hr />
              </Grid>

              <Grid
                container
                spacing={2}
                className={classes.gridContainer}
                direction="column"
              >
                <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                  <Tooltip title={'videos.type'}>
                    <SelectInput
                      fullWidth
                      label="Tipo"
                      source={'type'}
                      choices={[
                        { id: 'trailer', name: 'Trailer' },
                        { id: 'lesson', name: 'Aula' },
                        { id: 'lesson-spondered', name: 'Aula Extra' },
                      ]}
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <Tooltip title={'videos.vimeo_id'}>
                    <TextInput
                      fullWidth
                      label="Video ID"
                      source="vimeo_id"
                      validate={[
                        required('Obrigatório'),
                        number('Mínimo 5 caracteres numéricos'),
                      ]}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'videos.duration'}>
                    <TextInput
                      fullWidth
                      label="Duração do vídeo em segundos"
                      source="duration"
                      validate={[
                        required('Obrigatório')
                      ]}
                    />
                  </Tooltip>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  )
}
